/**
 * Strapi `filters` fragment selecting only "active" community members for the
 * Resident Directory and other public user listings: not soft-deleted, not
 * blocked, and not archived.
 *
 * Single source of truth for the directory's user query. It is referenced by
 * every frontend site that lists members (userStore, AuthContext) so the three
 * conditions cannot drift apart in copy-pasted objects — the drift that let
 * archived users keep showing up in the directory (MWBI-896).
 *
 * The server-side users-permissions `find` controller is the authoritative gate
 * (it also hides minors and never ships a hidden row over the wire). But site
 * admins bypass that server gate by design — so without this client-side filter
 * an admin browsing /users would still see archived members. The admin's own
 * "Archived" management tab uses a separate, unfiltered fetch, so it is
 * unaffected and still lists archived users.
 *
 * Mirrors the backend `ACTIVE_USER_WHERE` in
 * cms/server/src/utils/active-user-filter.ts.
 */
export const ACTIVE_USER_FILTERS = {
  deletedAt: { $null: true },
  blocked: { $ne: true },
  isArchived: { $ne: true },
};
